import { render, staticRenderFns } from "./JP.vue?vue&type=template&id=c01604dc&scoped=true&"
import script from "./JP.vue?vue&type=script&lang=js&"
export * from "./JP.vue?vue&type=script&lang=js&"
import style0 from "./JP.vue?vue&type=style&index=0&id=c01604dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01604dc",
  null
  
)

export default component.exports